<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md8>
        <material-card>
          <ValidationObserver ref="form" v-slot="{ passes }">
            <v-form @submit.prevent="passes(changepassword)">
              <v-container py-0>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12>
                    <ValidationProvider
                      :name="$t('language.currentpassword')"
                      rules="required"
                      v-slot="{ errors }"
                      vid="currentpassword"
                    >
                      <v-text-field
                        v-model="vModel.currentpassword"
                        :label="$t('language.currentpassword')"
                        :error-messages="errors[0]"
                        :type="'password'"
                      />
                    </ValidationProvider>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <ValidationProvider
                      :name="$t('language.password')"
                      rules="required"
                      v-slot="{ errors }"
                      vid="password"
                    >
                      <v-text-field
                        v-model="vModel.password"
                        :label="$t('language.password')"
                        :error-messages="errors[0]"
                        :type="'password'"
                      />
                    </ValidationProvider>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <ValidationProvider
                      :name="$t('language.confirmpassword')"
                      rules="confirmed:password"
                      v-slot="{ errors }"
                      vid="confirmpassword"
                    >
                      <v-text-field
                        v-model="vModel.confirmpassword"
                        :label="$t('language.confirmpassword')"
                        :error-messages="errors[0]"
                        :type="'password'"
                      />
                    </ValidationProvider>
                  </v-flex>
                  <v-flex xs12 text-xs-right>
                    <v-btn type="submit" class="mx-0 font-weight-light" color="general">
                      Change Password
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </ValidationObserver>
        </material-card>
      </v-flex>
      <v-flex xs12 md4>
        <material-card class="v-card-profile">
          <!-- <v-avatar
            slot="offset"
            class="mx-auto d-block"
            size="130"
          >
            <img
              src="https://bookingagentinfo.com/wp-content/uploads/2014/12/Travis-Scott-Contact-Information.jpg"
            >
          </v-avatar> -->
          <v-card-text class="text-xs-center">
            <h6 class="category text-gray font-weight-thin mb-3">
              {{ $store.getters.user.designation }}
            </h6>
            <h4 class="card-title font-weight-light">
              {{ $store.getters.user.name }}
            </h4>
            <!-- <p class="card-description font-weight-light">You wrote that yourself? wow congrats dude, really, that's very cool.
            i just told everyone in my family about it, everybody thinks that's very impressive and asked me to congratulate you.
            they want to speak to you in person, if possible, to give you their regards.
            they also said they will tell our distant relatives in christmas supper and in NYE they will ignite fireworks that spell your name.
            i also told about this enormous deed to closer relatives, they had the same reaction. they asked for your address so they can send congratulatory cards and messages.
            my friends didn't believe me when i told them i knew the author of this gigantic feat, really, they were dumbstruck, they said they will make your name echo through years and years to come.
            when my neighbour found out about what you did, he was completely dumbstruck too, he wanted to know who you are and he asked (if you have the time, of course) if you could stop by to receive gifts, congratulations and handshakes.
            with the spreading of the news, a powerful businessman of the area decided to hire you as the CEO of his company because of this tremendous feat and at the same time an important international shareholder wants to sponsor you to give speeches
            and teach everybody how to do as you did so the world becomes a better place. you have become famous not only here but also everywhere, everybody knows who you are. the news spread really fast and mayors of all cities are setting up
            porticos, ballons, colossal boom speakers, anything that can make your name stand out more and see which city can congratulate you the hardest for this magnificent feat.</p>
            <v-btn
              color="general"
              round
              class="font-weight-light"
            >Follow</v-btn> -->
          </v-card-text>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import Base from "../shared/Base.vue";
export default {
  extends: Base,
  data() {
    return {
      vModel: {
        password: null,
        oldpassword: null,
        confirmpassword:null
      },
    };
  },
  methods: {
    changepassword() {
      if (this.loading) return;
      this.loading = true;
      axios.post("changepassword", this.vModel).then(
        () => {
          this.$store.dispatch(
            "showSuccessMessage",
            this.$t("language.passwordsetsuccessful")
          );
          this.loading = false;
          this.vModel = {
            password: null,
            currentpassword: null,
            confirmpassword:null
          };
          setTimeout(() => {
            this.$nextTick(() => {
              this.$refs.form.reset();
            });
          }, 300);
        },
        () => {
          this.loading = false;
        }
      );
    },
  },
};
</script>
